import Button from 'components/_parts/atoms/button';
import Label from 'components/_parts/atoms/label';
import TooltipCustom from 'components/_parts/atoms/tooltip';
import { processLabel } from 'components/types/businessProcess';
import labelBp from './label';

function Primary({ cvcPrimary, setSelectedData }: processLabel) {
  const labelPrimary = labelBp('primary');
  return (
    <div
      className={`content_cvc_primary ${
        cvcPrimary?.length >= 2 ? 'd-flex gapCol16' : ''
      }`}
    >
      <div
        className={`${
          cvcPrimary?.length >= 2 ? 'content_cvc_primary_grid' : ''
        }`}
      >
        {cvcPrimary?.map((val) => (
          <div
            id="cvc-primary"
            key={val.process_id}
            className={`custm_list_cvc ${
              cvcPrimary?.length >= 2 ? 'gap10Cvc' : 'gap20Cvc'
            }`}
            aria-hidden="true"
            style={{
              cursor: 'pointer',
              margin: cvcPrimary?.length >= 2 ? '4px 0px' : '8px 0px',
            }}
            onClick={() => {
              setSelectedData({
                lvl: '2',
                process_id: val.process_id,
                type: labelPrimary,
                backgroundColor: '#2E9CFF',
                name: val.name,
                order: val.order,
              });
            }}
          >
            <Button
              style={{
                width: '32px',
                height: '28px',
                backgroundColor: '#2E9CFF',
                boxShadow: '0 4px 4px 0 rgba(0,0,0,0.3)',
              }}
            >
              {val.no}
            </Button>
            <div style={{ width: '100%', display: 'flex' }}>
              <TooltipCustom name={val?.name}>
                <Label className="clampTitle">{val?.name}</Label>
              </TooltipCustom>
              <Button
                style={{
                  backgroundColor: '#2E9CFF',
                  height: '20px',
                  padding: '0px 20px',
                  fontWeight: '600',
                  marginLeft: 'auto',
                  display: cvcPrimary?.length >= 2 ? 'none' : '',
                }}
              >
                {labelPrimary}
              </Button>
            </div>
          </div>
        ))}
      </div>
      {cvcPrimary?.length >= 2 && (
        <div className="custm_list_cvc my-auto" style={{ padding: '6px 18px' }}>
          <Button
            style={{
              backgroundColor: '#2E9CFF',
              height: '20px',
              padding: '0px 20px',
              fontWeight: '600',
              marginLeft: 'auto',
            }}
          >
            {labelPrimary}
          </Button>
        </div>
      )}
    </div>
  );
}

export default Primary;
